import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Icon } from '@material-ui/core';
import { Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { FormGroup, FormControlLabel, Checkbox ,CircularProgress} from '@mui/material';
import PlanningService from "../../../services/PlanningService";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#425b8a",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
 
  

  const generateDateRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);  // Incrémente d'un jour
    }
    return dates;
};

const groupDaysByMonth = (dates) => {
    const months = {};
    dates.forEach(date => {
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        if (!months[monthKey]) {
            months[monthKey] = [];
        }
        months[monthKey].push(date.getDate());
    });

    return months;
};

function CalendarView({startDate, endDate,datatables,periode}) {
 
  
    const startDates = new Date(startDate); 
    const endDates = new Date(endDate);

    const dates = generateDateRange(startDates, endDates);
    const monthsGrouped = groupDaysByMonth(dates);
    const [loading, setLoading] = useState(false);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [datatable,setDataTable]=useState([]);
    const [user,setUser]=useState(0);
    const [aff,setAff]=useState(true);

    const handleChangeTDR = (event) => {
      setSelectedDay({ ...selectedDay, statut: event.target.value });
    };
  
    const handleCellClick = (day,id) => {
      setUser(id);
      setSelectedDay(day);
      setDialogOpen(true);  
    };

    const handlevalide = () => {
        // Fermer le dialogue et réinitialiser les autres états
        
        setAff(false);
        setLoading(true);
        PlanningService.validatemission(selectedDay,periode,user).then((result) => {
          if (result && result.data) {
           setDataTable(result.data);
           setDialogOpen(false);
            setUser(0);
            setSelectedDay(null);
           setAff(true);
           setLoading(false)
          }
          else{
              setDialogOpen(false);
              setLoading(false);
          }
        });
    };
  
    const handleCLose=()=>{
      setDialogOpen(false);
    }
    
    const monthKeys = Object.keys(monthsGrouped).sort((a, b) => {
        const [yearA, monthA] = a.split('-').map(Number);
        const [yearB, monthB] = b.split('-').map(Number);
        return yearA === yearB ? monthA - monthB : yearA - yearB;
    });
    console.log("monthkeys",monthKeys);
    

    const moisEnFrancais = (mois) => {
      const moisArray = [
          "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", 
          "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];
      
      if (mois >= 1 && mois <= 12) {
          return moisArray[mois - 1]; 
      } else {
          return "Mois invalide"; 
      }
  };
     
  return (
      <React.Fragment>
           <div>
            {aff&&
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                        <StyledTableCell style={{ fontWeight: 'bold', backgroundColor: '#ffffff00' }}></StyledTableCell>
                        {monthKeys.map((monthKey) => {
                        const [year, month] = monthKey.split('-').map(Number);
                        const monthName=moisEnFrancais(month);
    
                        const daysInMonth = monthsGrouped[monthKey].length;
                        return (
                            <StyledTableCell  colSpan={daysInMonth} key={monthKey} style={{ textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f0f0f0',color:'black' }}>
                               {monthName}
                            </StyledTableCell>
                        );
                        })}
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0',position: 'sticky',left: 0,zIndex: 1}}>
                          Demandeur
                        </StyledTableCell>
                        {monthKeys.map((monthKey) => (
                            monthsGrouped[monthKey].map(day => (
                                <StyledTableCell key={day} align="center" style={{ padding: '10px', border: '1px solid #ddd' }}>
                                {day}
                                </StyledTableCell>
                            ))
                        ))}
                    </TableRow>
                    </TableHead>
                    <TableBody>
                      {(() => {
                        const list = datatable.length > 0 ? datatable : datatables;

                        return list.map((row, rowIndex) => (
                          <StyledTableRow key={rowIndex}>
                           <StyledTableCell
                              component="th"
                              scope="row"
                              style={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 1,
                              }}
                            >
                              {row.name}
                            </StyledTableCell>
                            {monthKeys.map((monthKey) => {
                              let mergedCells = [];
                              return monthsGrouped[monthKey].map((day, dayIndex) => {
                                const existingCell = mergedCells.find((c) => c.start <= day && c.end >= day);
                                if (existingCell) return null;
                                
                                let cellContent = null;
                                row.details.forEach((ts) => {
                                  const moisDebut = parseInt(ts.mois, 10);
                                  const moisActuel = parseInt(monthKey.split('-')[1], 10);
                                  const jourDebut = parseInt(ts.jour, 10);
                                   const jourFin = parseInt(ts.jour, 10);
                                  const isHighlighted = day === jourDebut  && moisDebut === moisActuel;
                                  
                                  if (isHighlighted && !cellContent) {
                                    cellContent = (
                                      <StyledTableCell
                                          key={`${monthKey}-${dayIndex}`}
                                          style={{
                                            border: '1px solid #ddd',
                                            backgroundColor: ts.statut === 'valide' ? '#78b785' : ts.statut === 'refuse' ? 'red' : '#87CEEB',
                                            color: 'white',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s',
                                          }}
                                          //onClick={() => handleCellClick(ts, row.user_id)}
                                          onClick={() => {
                                            if (ts.statut !== 'valide' && ts.statut !== 'refuse') {
                                              handleCellClick(ts, row.user_id);
                                            }
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#5B9BD5';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = ts.statut === 'valide' ? '#78b785' : ts.statut === 'refuse' ? 'red' : '#87CEEB';
                                          }}
                                        
                                      >
                                       <Icon style={{ marginRight: '4px', fontSize: '15px' }}>{ts.code}</Icon>
                                      </StyledTableCell>
                                    );
                                    mergedCells.push({ start: jourDebut, end: jourFin });
                                  }
                                });
                                
                                return cellContent || (
                                  <StyledTableCell
                                    key={`${monthKey}-${dayIndex}`}
                                    style={{
                                      border: '1px solid #ddd',
                                      backgroundColor: 'transparent',
                                      color: 'black',
                                      textAlign: 'center',
                                    }}
                                    colSpan={1}
                                  ></StyledTableCell>
                                );
                              });
                            })}
                          </StyledTableRow>
                        ));
                      })()}
                    </TableBody>

                  </Table>
                </TableContainer>
            }
           </div> 
           <div>
           {dialogOpen && (
                <Dialog
                open={dialogOpen}
                onClose={handleCLose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">
                {"Validation Planning"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Grid container spacing={4}>
                        <Grid item xs={4}>
                           Intutilé :
                        </Grid>
                        <Grid item xs={8}>
                             {selectedDay.mission_title}
                        </Grid>
                        <Grid item xs={4}>
                            Date de départ:
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                id="date_begin"
                                size="small"
                                variant="outlined"
                                type="date"
                                value={selectedDay.date_begin}
                                name="date_begin"
                                onChange={(e) => {
                                  const newDate = e.target.value; 
                                  const day = (parseInt(newDate.split('-')[2], 10)).toString();
                                  const month= (parseInt(newDate.split('-')[1])).toString();
                                  setSelectedDay(prevSelectedDay => ({ 
                                      ...prevSelectedDay, 
                                      date_begin: newDate, 
                                      debut: day ,
                                      mois_debut:month
                                  }));
                              }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            Date de retour:
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                id="date_end"
                                size="small"
                                variant="outlined"
                                type="date"
                                value={selectedDay.date_end}
                                name="date_end"
                                onChange={(e) => {
                                  const newDate = e.target.value; 
                                  const day = (parseInt(newDate.split('-')[2], 10)).toString();
                                  const month= (parseInt(newDate.split('-')[1])).toString();
                                  setSelectedDay(prevSelectedDay => ({ 
                                      ...prevSelectedDay, 
                                      date_end: newDate, 
                                      fin: day ,
                                      mois_fin:month
                                  }));
                              }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                         
                        </Grid>
                        <Grid item xs={8}>
                            <FormGroup>
                                <FormControlLabel
                                control={<Checkbox checked={selectedDay.statut === 'valide'} onChange={() => handleChangeTDR({ target: { value: 'valide' } })} />}
                                label="Valider"
                                />
                                <FormControlLabel
                                control={<Checkbox checked={selectedDay.statut === 'refuse'} onChange={() => handleChangeTDR({ target: { value: 'refuse' } })} />}
                                label="Réfuser"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid item xs={4}>
                         
                        </Grid>
                        <Grid item xs={8}>
                          {selectedDay &&selectedDay.statut==='refuse'&&
                             <TextField
                             fullWidth
                             rows={3}
                             multiline
                             id="outlined-basic"
                             size="small"
                             label="Raison"
                             variant="outlined"
                             value={selectedDay.raison}
                             name="raison"
                             onChange={(e) => setSelectedDay({ ...selectedDay, raison: e.target.value })}
                           />
                          }
                        </Grid>
                    </Grid>
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                     <Button
                      onClick={handlevalide}
                      variant="outlined"
                      disabled={loading} 
                      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} 
                    >
                      {loading ? 'Validation encours...' : 'Valider'}
                    </Button>
                <Button onClick={handleCLose} autoFocus variant="outlined">
                    Fermer
                </Button>
                </DialogActions>
             </Dialog>
             
            )}
           </div>
      </React.Fragment>
  );
}

export default CalendarView;